import React from 'react';
import {withTranslationsAsProps} from '../../../components/translations';
import './unavailable-label.less';

export const UnavailableLabel = ({unavailableMessage}) => {
    return (<div className="unavailable-label label label--black"><span title={unavailableMessage} aria-label={unavailableMessage} className="unavailable-label__message">{unavailableMessage}</span></div>);
};

export default withTranslationsAsProps({
    'tripboards.error.unavailable': 'unavailableMessage'
})(UnavailableLabel);




// WEBPACK FOOTER //
// ./src/universal/tripboard/unavailable-label/components/unavailable-label.js